
class HXFormFieldReference extends HXFormField {

    constructor(inputName,formName) {
        super(inputName ,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = '' + this.getValue();
            if (!this.getOptional() && value === '0') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }

            if (alertResult === true) super._validateFieldAlert();
        }
        return this.validationPassed;
    }


    /**
     * Todo
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'reference');
    }

    /**
     * Feld leeren
     */
    setClear(){
        this.setValue(0,'','','');
    }

    /**
     * @returns {int} id
     */
    getValue() {
        return document.getElementsByName('refPool_' + this.inputName + '_id')[0].value;
    }

    /**
     *
     * @returns {string} Type
     */
    getValueType() {
        return document.getElementsByName('refPool_' + this.inputName + '_type')[0].value;
    }


    /**
     * @param {int} id id des Files
     * @param {string} type link, bookmark, file
     * @param {string} text angezeigter Text im Feld
     * @param {string} link link fuer angezeigten Text
     */
    setValue(id, type, text="", link=""){
        var dsp = '';
        if (hx.cint(id)===0) {
            dsp = 'none';
            id = '';
            type = '';
            link = '';
        }

        var container = $('#refPool_' + this.inputName + '_content');
        var content = hx.guiSetEllipsis(text, container.width(), 'center');
        if (link!=='') content = '<a target=_blank href=\"'+link+'\">' + content + '</a>';
        container.html(content);

        document.getElementsByName('refPool_' + this.inputName + '_id')[0].value = id;
        document.getElementsByName('refPool_' + this.inputName + '_type')[0].value = type;
        if (document.getElementById(this.inputName + "_btn_clear")) document.getElementById(this.inputName + "_btn_clear").style.display = dsp; //Readonly nicht vorhanden
    }

    /**
     * Suchfeld Events einhaengen
     */
    displayInit() {
        if (this.fieldExists()===true && this.getEditable()===true) {
            //Medienpool Icon
            document.getElementById(this.inputName + "_btn_link").addEventListener("click", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                hx.eventCancelBubble(event);
                var stateparam = document.getElementById(this.inputName + "_btn_link").getAttribute('data-hx-stateparam');
                HXFormFieldUtils.openCmshxMedienpool(this.formVars.root,stateparam);
            });

            //Loeschen Icon
            document.getElementById(this.inputName + "_btn_clear").addEventListener("click", (event) => { //arrow function erlaubt, das this in der Funktion das Hauptobjekt ist.
                this.setClear();
            });
        }
    }

}




